import queryClient from "single-spa/react-app/query-client";

import type { IAiTrackerCampaign } from "../types";

import { campaignOptions } from "./llmTrackerCampignsQueries";

export const llmTrackerCampaignsQueryClient = {
    getCampaigns: async (): Promise<IAiTrackerCampaign[]> => {
        return await queryClient.ensureQueryData<IAiTrackerCampaign[]>({
            ...campaignOptions.getAll(),
            revalidateIfStale: true,
        });
    },

    getCampaignById: async (id: string): Promise<IAiTrackerCampaign | null> => {
        return await queryClient.ensureQueryData<IAiTrackerCampaign>({
            ...campaignOptions.getById(id),
            revalidateIfStale: true,
        });
    },

    prefetchCampaigns: async (): Promise<void> => {
        await queryClient.prefetchQuery(campaignOptions.getAll());
    },

    prefetchCampaignById: async (id: string): Promise<void> => {
        await queryClient.prefetchQuery(campaignOptions.getById(id));
    },

    refreshCampaigns: async (): Promise<void> => {
        await queryClient.invalidateQueries({ queryKey: campaignOptions.getAll().queryKey });
    },

    getCampaignsFromCache: (): IAiTrackerCampaign[] => {
        return queryClient.getQueryData<IAiTrackerCampaign[]>(campaignOptions.getAll().queryKey);
    },
};
